import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { laChannelCount } from 'src/constants/planData/latinoPlanData'
import { promoCodes } from 'src/constants'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <LatinoTemplateDefault
        location={props.location}
        lang="es"
        market="latino"
        //REMOVED: univision_removed video and annotations
        // video={videos.latino.videoUrl}
        // annotations={videos.latino.annotations}
        //REPLACED: univision_removed poster images
        poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
        posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
        title={<>Descuento para amigos y familiares</>}
        offerCode={promoCodes.latino_special_offer}
        subtitle={
          <>
            Accede desde solo <span className="green-underline">$1.99</span> el primer mes y mira
            <span className="desktop-line-break">
              más de {laChannelCount} canales con deportes, noticias y{' '}
            </span>
            entretenimiento en español. Oferta por tiempo limitado.
          </>
        }
        networkSet="entertainmentLatino"
        noteLink="/la/special-offer/"
        discountedPrice="1.99"
        noIndex={true}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 670px;
  }
`
